// extracted by mini-css-extract-plugin
export var textInput = "_if-0";